export const BREAD_CRUMB = [
    { name: 'create plan', path: `/ooh/planner` },
    { name: 'my poi', path: `/ooh/poi/packages` },
    {
      name: 'create custom poi package',
      path: `/ooh/poi/packages/create-custom-poi-package`,
    },
  ]
  